import { render, staticRenderFns } from "./DryingGraphLegend.vue?vue&type=template&id=4c8b1670&scoped=true&"
import script from "./DryingGraphLegend.vue?vue&type=script&lang=ts&"
export * from "./DryingGraphLegend.vue?vue&type=script&lang=ts&"
import style0 from "./DryingGraphLegend.vue?vue&type=style&index=0&id=4c8b1670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b1670",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
